module.exports = __webpack_public_path__ + "97e7391fc229f86710079f4558e23078.png";